import { makeStyles } from "@material-ui/styles";

export default makeStyles((theme) => ({
  root: {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "space-around",
    overflow: "hidden",
    backgroundColor: theme.palette.background.paper,
  },
  imageList: {
    width: "100%",
    height: "100%",
  },
  tableImageList: {
    width: "100%",
    height: "100%",
    cursor: "pointer",
  },
  icon: {
    color: "rgba(255, 255, 255, 0.54)",
  },
  itemBar: {
    height: "1.4rem",
    display: "flex",
    alignItems: "center",
  },
  bottomButtonsGrid: {
    color: "#fff",
    height: "3rem",
    position: "absolute",
    marginLeft: "-45%",
    left: "50%",
    width: "90%",
    bottom: "5rem",
    justifyContent: "center",
  },
  notOursButton: {
    color: "#FFF",
    background: theme.palette.colors.rose600,
  },
  dialogSubtitle: {
    color: theme.palette.text.secondary,
  },
  sectionTitle: {
    fontWeight: 600,
    marginBottom: "0.5rem",
  },
  itemRow: {
    display: "flex",
    alignItems: "center",
    gap: "1rem",
    padding: "0.75rem 0",
    borderBottom: `1px solid ${theme.palette.divider}`,
    "&:last-child": {
      borderBottom: "none",
    },
  },
  itemSku: {
    fontWeight: 600,
    minWidth: "6rem",
  },
  itemCondition: {
    display: "flex",
    alignItems: "center",
    gap: "0.5rem",
    flex: 1,
  },
  conditionSelect: {
    minWidth: "9rem",
  },
  itemThumbnails: {
    display: "flex",
    gap: "0.25rem",
  },
  itemThumbnail: {
    width: "3.5rem",
    height: "3.5rem",
    objectFit: "cover",
    borderRadius: "4px",
    cursor: "zoom-in",
  },
  imagePreview: {
    maxWidth: "none",
    padding: "4px",
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[8],
  },
  imageViewer: {
    display: "block",
    maxWidth: "90vw",
    maxHeight: "85vh",
    cursor: "zoom-out",
  },
  imagePreviewImage: {
    display: "block",
    maxWidth: "min(480px, 80vw)",
    maxHeight: "70vh",
    borderRadius: "4px",
  },
}));
